module.exports = __webpack_public_path__ + "media/images/new_home/save-black-09b284f54e4b5dbbcf9eeb0fd216c536.png";